import { render, staticRenderFns } from "./FinancialModule.vue?vue&type=template&id=da55d67c&scoped=true&"
import script from "./FinancialModule.vue?vue&type=script&lang=js&"
export * from "./FinancialModule.vue?vue&type=script&lang=js&"
import style0 from "./FinancialModule.vue?vue&type=style&index=0&id=da55d67c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da55d67c",
  null
  
)

export default component.exports